// Users (admin only), the way App admin and the Lender Hub do it: an admin adds a person with a role and gets a
// one-time password, shown once, to hand over; the person chooses their own at the first sign-in. An admin changes
// roles, disables / enables, resets a forgotten password (a new one-time password) and resets 2-step for someone
// who lost their phone. Nobody changes their own role or status.
import { z } from 'zod'
import { Role, User, UserStatus } from './session'

export const AddUserInput = z.object({
  name: z.string().trim().min(2, 'At least 2 characters').max(100, 'At most 100 characters'),
  email: z.email('Not an email address').trim().toLowerCase(),
  role: Role,
})
export type AddUserInput = z.infer<typeof AddUserInput>

export const UpdateUserInput = z.object({ role: Role.optional(), status: UserStatus.optional() })
export type UpdateUserInput = z.infer<typeof UpdateUserInput>

/** Shown once to the admin, never stored readable and never shown again. */
export const OneTimePassword = z.object({ user: User, one_time_password: z.string() })
export type OneTimePassword = z.infer<typeof OneTimePassword>

export interface UsersApi {
  listUsers(): Promise<User[]>
  addUser(input: AddUserInput): Promise<OneTimePassword>
  updateUser(userId: string, input: UpdateUserInput): Promise<User>
  /** a new one-time password; the person chooses their own at the next sign-in */
  resetPassword(userId: string): Promise<OneTimePassword>
  /** 2-step off for them until they turn it on again (or set it up at sign-in when it is required) */
  resetTwoStep(userId: string): Promise<User>
}
